import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70915bd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-sale-type" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rules", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("loading...")
const _hoisted_4 = {
  key: 1,
  class: "after-sale-type-content"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" This after-sale is provided by   ")
const _hoisted_6 = { class: "apple" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("   store ")
const _hoisted_8 = {
  key: 2,
  class: "not-data-tip"
}
const _hoisted_9 = { class: "not-data-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "We recommend you contact seller at first to reach an agreement for fast resolution on aftersale.", -1))
const _hoisted_11 = { class: "btn" }

import { reactive, ref, inject } from 'vue'
import { useRoute, useRouter } from "vue-router";
import { Toast } from 'vant';
import Header from "@/components/header/header.vue";
import AfterGoodsCard from "./component/afterGoodsCard.vue";
import AfterType from "./component/afterType.vue";
import BottomBtn from "./component/afterBottomBtn.vue";
import KiliButton from "@/components/KiliButton.vue";
import { linkChat,getRuleUrl } from '@/hooks/index'

export default /*#__PURE__*/_defineComponent({
  __name: 'afterSaleType',
  setup(__props) {

const $http: any = inject("$http");
const $store: any = inject("$store");
const route = useRoute()
const router = useRouter();
let goodsData:any = ref([])

let orderGoods:any = ref({}) //订单商品信息
let typeDefault = [
    {
        type: '1',
        leftIcon: 'https://image.kilimall.com/kenya/wap/afterSales/ic_return_2x.png',
        title: 'Return & Refund',
        explain: 'Have problem with goods received and need to return for refund',
        rightIcon: 'arrow',
        currentShow: 'support_return_refund'
    },
    {
        type: '2',
        leftIcon: 'https://image.kilimall.com/kenya/wap/afterSales/ic_refund_2x.png',
        title: 'Refund',
        explain: 'Not received or received less and no need return the goods, or apply after negotiating with the seller',
        rightIcon: 'arrow',
        currentShow: 'support_refund'
    },
    {
        type: '4',
        leftIcon: 'https://image.kilimall.com/kenya/wap/afterSales/ic_exchange_2x.png',
        title: 'Exchange',
        explain: 'Received goods and need to return for a new available one)',
        rightIcon: 'arrow',
        currentShow: 'support_exchange'
    },
    {
        // 目前售后2.0版本售后维修是直接打开轻流工单页面
        path: '/afterSaleRepair/',
        leftIcon: 'https://image.kilimall.com/kenya/wap/afterSales/ic_repair_2x.png',
        title: 'Repair',
        // explain: 'Dissatisfied with the goods, you can negotiate with the merchant to exchange the goods',
        rightIcon: 'arrow',
        currentShow: 'support_repair'
    },
]
let typeData: any = ref([])
let btnData = reactive([
    // {
    //     plain: true,
    //     textColor: '#333333',
    //     bordersColor: '#999999',
    //     radiusSize: '6px',
    //     title: 'Contact us',
    // },
    {
        plain: false,
        icon: "chat-o",
        textColor: '#E04545',
        bordersColor: '#E04545',
        radiusSize: '6px',
        title: 'Contact Seller',
    },
])
let showDialog = ref(false)
let showData = ref({
    isShow:false,
    loading:true,
    msg:'Sorry, the product has already been applied for aftersale and cannot be applied again.'
})
let selectAfterType = ref({})
let ruleUrl = ref('')
const selectType = (val: any) => {
    if(val.currentShow === "support_repair") {
        window.location.href = 'https://qingflow.com/f/7c1fff60'
    }else{
        // 去掉引导与商家协商弹窗
        //  showDialog.value = true
        handleContinue()
    }
    selectAfterType.value = val
    $store.setAfterType(selectAfterType.value)
   

}
// //跳转到聊天
const handleContact = () => {
    linkChat($http,$store,goodsData.value[0].store_id)
    showDialog.value = false
}
const handleContinue = () => {
    showDialog.value = false
    router.push({
        name: 'afterSaleInfo',
    })

}
const goToRule = () => {
    window.open(ruleUrl.value)
}
const jumpShop = () => {
    //店铺跳转
    router.push({
        name: "shop",
        params: {
            id: goodsData.value[0].store_id,
        },
    });

}
// 获取当前订单id下的可售后类型
const getAfterSaleType = async () => {
    let params: any = {
        id: route.params.id
    }
    getRuleUrl().then((res: any) => {
        ruleUrl.value = res.agreements.aftersale_rules.url
    })
    await $http.getAfterSaleTypeList(params).then((res: any) => {
        if (res.code === 200) {
            showData.value.isShow = true
            let data = JSON.parse(JSON.stringify(res.data))
            for (let i in data.available_service) {
                if (data.available_service[i] && i != "bat_only") {
                    typeData.value.push(...typeDefault.filter(item => item.currentShow == i))
                }
            }
            goodsData.value = data.orders
            // 商品信息可能是对象,也可能是数组,最终都将其转换为数组,这样不管是其为对象时,嵌套了几个对象,都能正常显示
            if(Object.prototype.toString.call(goodsData.value[0].order_goods) === '[object Object]'){
                let arr:any = []
                goodsData.value.forEach((item:any)=>{
                    for(let keys in item.order_goods){
                        arr.push(item.order_goods[keys])
                    }
                })
                orderGoods.value = goodsData.value[0].order_goods = arr
            }else{
                let arr:any = []
                goodsData.value.forEach((item:any)=>{
                    arr = [].concat(arr,item.order_goods)
                })
                orderGoods.value =arr
            }
            $store.setAfterSaleGoods(goodsData.value)
            $store.setAfterBat(data.available_service['bat_only'])
        }else{
            showData.value.isShow = false
            Toast(res.msg)
        }
         showData.value.loading = false

    })
}
getAfterSaleType()

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      title: "Choose Service Type",
      backgroundColor: "#FFFFFF",
      fontColor: "#303133",
      skipPath: "/afterSale",
      ios_app: true
    }, {
      right: _withCtx(() => [
        _createElementVNode("div", {
          class: "header-right",
          onClick: goToRule
        }, [
          _createVNode(_component_van_icon, {
            name: "question-o",
            size: "0.5rem"
          }),
          _hoisted_2
        ])
      ]),
      _: 1
    }),
    (_unref(showData).loading)
      ? (_openBlock(), _createBlock(_component_van_loading, {
          key: 0,
          class: "loading_box",
          size: "24"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(showData).isShow&&!_unref(showData).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(goodsData)[0] && _unref(goodsData)[0].logistics_type != 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "after-sale-type-tip",
                onClick: jumpShop
              }, [
                _hoisted_5,
                _createElementVNode("u", _hoisted_6, _toDisplayString(_unref(goodsData)[0].store_name), 1),
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          _createVNode(AfterGoodsCard, { goodsData: _unref(orderGoods) }, null, 8, ["goodsData"]),
          _createVNode(AfterType, {
            data: _unref(typeData),
            onClick: selectType
          }, null, 8, ["data"])
        ]))
      : _createCommentVNode("", true),
    (!_unref(showData).isShow&&!_unref(showData).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_van_image, {
            width: "1.6rem",
            height: "1.6rem",
            fit: "cover",
            src: 'https://image.kilimall.com/kenya/wap/afterSales/opps_2x.png'.webpFilters()
          }, null, 8, ["src"]),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(showData).msg), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(BottomBtn, {
      onClick: handleContact,
      btnData: _unref(btnData)
    }, null, 8, ["btnData"]),
    _createVNode(_component_van_popup, {
      show: _unref(showDialog),
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : showDialog = $event)),
      class: "after-dialog",
      closeable: ""
    }, {
      default: _withCtx(() => [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(KiliButton, {
            plain: "",
            textColor: "#666666",
            bordersColor: "#99999",
            title: "Contact Seller",
            onClick: handleContact
          }),
          _createVNode(KiliButton, {
            textColor: "#E04545",
            bordersColor: "#E04545",
            title: "Continue",
            onClick: handleContinue
          })
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})